import { observer } from 'mobx-react';
import { CustomCommissurePointsBox } from '@/components/boxes/objectBoxes/CustomCommissurePointsBox/CustomCommissurePointsBox.tsx';
import { ObjectsKind } from '@/engine/app/interfaces.ts';

import type { FC } from 'react';
import type { IPlanningEntityProps } from '@/components/common/interfaces.ts';
import type { ObjectBoxInfo } from '@/engine/app/models/viewEntity/view.entity.ts';

export const ObjectBoxes: FC<IPlanningEntityProps<ObjectBoxInfo>> = observer(({ entity }) => {
  return (
    entity.kind === ObjectsKind.CommissurePoints && (
      <CustomCommissurePointsBox key={entity.order} objects={entity.objects} index={entity.order} label={entity.label} />
    )
  );
});
